"use client";
import {
  Modal,
  Box,
  IconButton,
} from "@mui/material";
import Image from "next/image";
import CloseIcon from "@mui/icons-material/Close";

interface DocumentModalProps {
  open: boolean;
  onClose: () => void;
  imageUrl: string;
  title: string;
}

export function DocumentModal({
  open,
  onClose,
  imageUrl,
  title,
}: DocumentModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: "blur(40px)",
            backgroundColor: "#28313666",
          },
        },
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Box
        sx={{
          width: { xs: "95%", md: "80%" },
          maxWidth: "800px",
          maxHeight: "90vh",
          position: "relative",
          outline: "none",
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            color: "#9E9E9F",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1,
            "&:hover": {
              backgroundColor: "rgba(158, 158, 159, 0.3)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Document Image */}
        <Box
          sx={{
            width: "100%",
            height: "80vh",
            borderRadius: "16px",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <Image
            src={imageUrl}
            alt={title}
            fill
            style={{
              objectFit: "contain",
            }}
          />
        </Box>
      </Box>
    </Modal>
  );
}